import React from "react";
import { IntercomProvider } from "react-use-intercom";

interface IntercomContextProviderProps {
    children: React.ReactNode;
}

const IntercomContextProvider = ({ children }: IntercomContextProviderProps): JSX.Element => {
    if (!window.APP_SETTINGS.intercomClientId) return <>{children}</>;
    return <IntercomProvider appId={window.APP_SETTINGS.intercomClientId}>{children}</IntercomProvider>;
};

export default IntercomContextProvider;
